import { render, staticRenderFns } from "./liveShareList.vue?vue&type=template&id=a61d8972&scoped=true&"
import script from "./liveShareList.vue?vue&type=script&lang=js&"
export * from "./liveShareList.vue?vue&type=script&lang=js&"
import style0 from "./liveShareList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./liveShareList.vue?vue&type=style&index=1&id=a61d8972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61d8972",
  null
  
)

component.options.__file = "liveShareList.vue"
export default component.exports